import _toConsumableArray from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";

/** Joins args into a className string
 *
 * @param {any} args list of objects, string, or arrays to reduce
 */
export function css() {
  // Adapted from https://github.com/JedWatson/classnames/blob/master/index.js
  var classes = [];
  var hasOwn = {}.hasOwnProperty;

  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  args.filter(Boolean).forEach(function (arg) {
    var argType = typeof arg;

    if (argType === 'string' || argType === 'number') {
      classes.push(arg);
    } else if (Array.isArray(arg) && arg.length) {
      var inner = css.apply(void 0, _toConsumableArray(arg));

      if (inner) {
        classes.push(inner);
      }
    } else if (argType === 'object') {
      for (var key in arg) {
        if (hasOwn.call(arg, key) && arg[key]) {
          classes.push(key);
        }
      }
    }
  });
  return classes.join(' ');
}